module.exports = __webpack_public_path__ + "media/images/header-background-2e995ff6.svg";